import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const formCva = cva(['overflow-hidden w-full'], {
  variants: {
    width: {
      'w-full': 'md:w-full',
      'w-1/2': 'md:w-1/2',
      'w-1/3': 'md:w-1/3',
      'w-2/3': 'md:w-2/3',
      'w-1/6': 'md:w-1/6',
    },
    alignment: {
      left: 'md:justify-start',
      center: 'md:justify-center',
      right: 'md:justify-end',
    },
  },
  defaultVariants: { alignment: 'center' },
})

export type FormCva = VariantProps<typeof formCva>
